/**
 * @desc 修改箱数-获取sku箱子信息
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inMaster.skuBoxInfo.Params, options?: any) {
  return updateResponse(
    http(URL + `/inMaster/skuBoxInfo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
